import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { Bold } from 'feather-icons-react/build/IconComponents';
import { registersuccess } from '../../../SweetAlert/SweetAlert';
import { postFoundSomethingWrong } from '../../../HttpRequest/issues';

const FoundSomethingWrong = ({showModal,isPopupVisible,handleCancel,masterDataId}) => {
    console.log("masterDataId inside the popup",masterDataId);
    const [messageInput, setMessageInput] = useState('');
    const [commentValue, setCommentValue] = useState("");

    const handleInputChange = (e) => {
        setMessageInput(e.target.value);
        setCommentValue(e.target.value);
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
          sendUserMessage();
        }
      };
    const handleOkButtonClick = () => {
    if (commentValue.trim() !== "") {
        sendUserMessage()
    }
    };
    const sendUserMessage = async () => {
        if (messageInput.trim() === '') return;
        const userId = localStorage.getItem("id");
        const parsedValue = parseFloat(userId);

        
        const newMessage = {
          comment: messageInput,
          category: 'Found SoMETHING WRONG',
          status:'OPEN',
          userId: parsedValue,
          masterDataEntityId:masterDataId
        };
        try {
          console.log("New message ===>",newMessage)
          const response = postFoundSomethingWrong(newMessage);
          setMessageInput('');
          response.then((data) => {
            console.log(data);
            if (data.request.status == 201) {
              handleCancel();
              registersuccess("Successfully registered the issue ");
              console.log("data sucess");
            } else {
              console.log("data error")
            }
          });
        } catch (error) {
          console.error('Error fetching data:', error);
        }
    };

    return (
      <div>
        <Modal
          title={<span style={{ color: 'blue',fontWeight:Bold }}>Please elaborate the issue *</span>}
          visible={isPopupVisible}
          onCancel={handleCancel}
          onOk={handleOkButtonClick}
          okButtonProps={{ disabled: commentValue.trim() === "" }}
        >
          <TextArea
            type="text"
            value={messageInput}
            placeholder="Write here.."
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
          />
        </Modal>
      </div>
    );
  };
  
  export default FoundSomethingWrong;
